import { BrowserRouter } from 'react-router-dom';
import './App.css';
import Layout from './components/layout';
import { AuthContextProvider } from './contexts/providers/AuthContextProvider';
import { WindowSizeProvider } from './contexts/providers/WindowSizeProvider';
import { PagingProvider } from './contexts/providers/PagingContextProvider';

function App() {
	return (
		<div className="App">
			<WindowSizeProvider>
				<BrowserRouter>
					<AuthContextProvider>
						<PagingProvider>
							<Layout />
						</PagingProvider>
					</AuthContextProvider>
				</BrowserRouter>
			</WindowSizeProvider>
		</div>
	);
}

export default App;
